import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from './BaseEditExtension.js';

@Entity()
export class BaseGeneralStudentDocumentationExtension extends BaseEditExtension {
  static override _class = 'BaseGeneralStudentDocumentationExtension';
}
